// src/pages/Education/occupancy.js
// Состояние наполненности ДДО. Единственный «статус» учётного модуля (ТЗ раздел 6).
// Занятость z = факт / мощность. Пороги приходят из /meta (occ_norm_min), НЕ хардкодятся.
//
// Важно: это клиентский ПРЕДПРОСМОТР для журнала и формы. Источник истины — бэкенд
// (RQ.24.05/RQ.24.06): в ответе списка приходит r.fill_state, и если он есть — журнал
// показывает именно его. occState() используется, когда сервер состояние не прислал
// (мок) и для live-предпросмотра в форме при вводе мощности/факта.

export const FILL_STATES = ['prof', 'norm', 'defic', 'nd'];

// Ключи в словаре i18n (stProf/stNorm/stDefic/stND) и CSS-класс пилюли совпадают с кодом.
export const STATE_I18N_KEY = {
  prof: 'stProf',
  norm: 'stNorm',
  defic: 'stDefic',
  nd: 'stND',
};

/**
 * @param {number|null} seats  проектная мощность
 * @param {number|null} kont   фактическая наполненность
 * @param {number} normMin     нижний порог «нормы» (из meta.thresholds.occ_norm_min)
 * @returns {'prof'|'norm'|'defic'|'nd'}
 *   nd     — мощность 0/нет данных: состояние не определяется (деление на 0), серая пилюля;
 *   defic  — z > 1.00: переполнение, красная;
 *   norm   — normMin ≤ z ≤ 1.00: янтарная;
 *   prof   — z < normMin: есть свободные места, зелёная.
 */
export function occState(seats, kont, normMin = 0.9) {
  if (seats == null || kont == null || seats === 0) return 'nd';
  const z = kont / seats;
  if (z > 1.0) return 'defic';
  if (z >= normMin) return 'norm';
  return 'prof';
}

// Отклонение мощность − факт для предпросмотра. null, если нечего считать (в UI → «—»).
export function occDeviation(seats, kont) {
  if (seats == null || kont == null) return null;
  return seats - kont;
}
